var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.locales),function(locale){return _c('li',{key:locale,staticClass:"bg-blue-400 text-pink-700 rounded p-1",on:{"click":function($event){return _vm.switchLocal(locale)}}},[_vm._v(_vm._s(locale)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }